import type { FunctionComponent } from 'react'
import { TickBoldIcon as SBTickBoldIcon } from '@which/seatbelt/src/components/Icons/Miscellaneous'

type Props = Parameters<typeof SBTickBoldIcon>[0]

export const TickIcon: FunctionComponent<Props> = (props) => <SBTickBoldIcon {...props} />
